<template>

<core-panel>

	<template v-slot:head>

		<h1>Level Ups</h1>

		<p>The dates and games for each level up.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in list" :item="{id: item.g}" v-bind:key="index" :count="item.l" :subtext="subtext(item.d)" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'levels',
			list: []
		}

	},

	methods: {

		setParams: function() {

			return {
				index: this.$route.params.index || ''
			}

		},

		response: function(json) {

			this.list = json.levels

		},

		subtext: function(value) {

			return this.$options.filters.formatDate(value, this.$util.date.format('Do', 'MMMM', 'YYYY'))

		}

	}

}

</script>